import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchDeleteConversationFailure,
  fetchDeleteConversationSuccess,
} from "../slices/features/deleteContact";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* deleteConversationSaga(action: any) {
  const { payload } = action;
  const { id, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.deleteConversation,
      baseUrl,
      id,
      meta
    );

    yield put(fetchDeleteConversationSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchDeleteConversationFailure({ statusCode, statusText }));
  }
}

export function* watchDeleteConversation() {
  yield takeLatest(
    RequestTypes.DELETE_CONVERSATION_REQUEST,
    deleteConversationSaga
  );
}
